/**
 * Контакты техподдержки. Переписки внутри портала пока нет (`docs/support-plan.md`), и до неё
 * помощь просят там, где до человека доходит быстрее всего: мессенджером, а срочное — звонком.
 *
 * Значения лежат в коде открытым текстом осознанно: их видит каждый вошедший, и прятать в
 * сборочные переменные то, что портал сам показывает на экране, значило бы усложнить смену
 * номера пересборкой образа, ничего при этом не скрыв.
 *
 * Номер хранится десятью цифрами, как в базе (ADR 0066): «как показать» решает `formatPhone`,
 * «как набрать» — `tel:`. Строка «+7 (986) …» здесь завела бы второе написание того же номера.
 */
export const SUPPORT_PHONE = '9865114971';

/** Набор номера. Приложению нужен номер без разделителей и со страной. */
export const SUPPORT_PHONE_HREF = `tel:+7${SUPPORT_PHONE}`;

/** Диалог в Telegram по номеру: отдельного публичного имени у поддержки нет. */
export const SUPPORT_TELEGRAM_URL = `https://t.me/+7${SUPPORT_PHONE}`;

/** Ссылка на профиль в MAX — из самого приложения: по номеру мессенджер профиль не открывает. */
export const SUPPORT_MAX_URL =
  'https://max.ru/u/f9LHodD0cOIpBgeMVc2GrEjUYoOShehvc8VA8dGYxQoiVYVcKzpfkPu3pmE';
